import React, { Suspense } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";
import { Preloader } from "../Components/Preloader/Preloader";
import { Dashboard } from "./State-Distributor/Dashboard/Dashboard.js";
import { Sidebar } from "../Components/Sidebar/Sidebar.js";
import { Topbar } from "../Components/Topbar/Topbar.js";
import { SignIn } from "./SignIn/SignIn.js";
import { Inventory } from "./State-Distributor/Inventory/index.js";
import { InventoryView } from "./State-Distributor/Inventory/InventoryView.js";
import { Settings } from "./State-Distributor/Settings/Settings.js";
import { BulkAddIncomeStock } from "./State-Distributor/Inventory/BulkAddIncomeStock.js";
import { BulkReorder } from "./State-Distributor/Inventory/BulkReorder.js";
import { Sales } from "./State-Distributor/OldSales/index.js";
import { NewBill } from "./State-Distributor/OldSales/NewBill.js";
import { ViewSales } from "./State-Distributor/OldSales/ViewSales.js";
import { Orders } from "./State-Distributor/Orders/index.js";
import { ViewOrders } from "./State-Distributor/Orders/OldViewOrders.js";
import { ManageOrders } from "./State-Distributor/Orders/ManageOrders.js";
import { SubDistributors } from "./State-Distributor/SubDistributorsMenu/index.js";
import { ViewSubDistributors } from "./State-Distributor/SubDistributorsMenu/ViewSubDistributors.js";
import { PaymentDues } from "./State-Distributor/PaymentsDues/index.js";
import { ViewPaymentsDues } from "./State-Distributor/PaymentsDues/ViewPaymentsDues.js";
import { Quotations } from "./State-Distributor/Quotations/index.js";
import { ViewQuotations } from "./State-Distributor/Quotations/viewQuotations.js";
import { NewQuotations } from "./State-Distributor/Quotations/NewQuotations.js";
import { SubDashboard } from "./Sub-Distributor/Dashboard/index.js";
import { SubInventory } from "./Sub-Distributor/Inventory/index.js";
import { SubSales } from "./Sub-Distributor/Sales/index.js";
import { SubOrders } from "./Sub-Distributor/Orders/index.js";
import { SubSettings } from "./Sub-Distributor/Settings/Settings.js";
import { SubViewAllSales } from "./Sub-Distributor/Dashboard/ViewAllSales.js";
import { SubViewSalesInvoice } from "./Sub-Distributor/Dashboard/ViewSalesInvoice.js";
import { SubAddIncomeStock } from "./Sub-Distributor/Inventory/AddIncomingStock.js";
import { SubReorder } from "./Sub-Distributor/Inventory/ReorderInventory.js";
import { SubInvoice } from "./Sub-Distributor/Invoice/index.js";
import { SubOrdersAddIncomeStock } from "./Sub-Distributor/Orders/OrdersAddIncomeStock.js";
import { SubOrdersReorder } from "./Sub-Distributor/Orders/OrdersReorder.js";
import { ViewDistributorInvoice } from "./Sub-Distributor/Invoice/ViewDistributorInvoice.js";
import { ManageDistributorsInvoice } from "./Sub-Distributor/Invoice/ManageDistributorInvoice.js";
import { ViewPosInvoice } from "./Sub-Distributor/Invoice/ViewPosInvoice.js";
import { SubSalesInvoice } from "./Sub-Distributor/Sales/SalesInvoice.js";
import { ManageSubDistributors } from "./State-Distributor/SubDistributorsMenu/ManageSubDistributors.js";
import { ViewSubDistributorsInvoice } from "./State-Distributor/SubDistributorsMenu/ViewSubDistributorsInvoice.js";
import { StateInvoice } from "./State-Distributor/Invoice/index.js";
import { StateViewDistributorInvoice } from "./State-Distributor/Invoice/OldViewDistributorInvoice.js";
import { StateManageDistributorsInvoice } from "./State-Distributor/Invoice/ManageDistributorInvoice.js";
import { StateViewPosInvoice } from "./State-Distributor/Invoice/OldViewPosInvoice.js";
import { SubQuotations } from "./Sub-Distributor/Quotations/index.js";
import { SubViewQuotations } from "./Sub-Distributor/Quotations/viewQuotations.js";
import { SubNewQuotations } from "./Sub-Distributor/Quotations/NewQuotations.js";
import { StateSales } from "./State-Distributor/Sales/index.js";
import { StateSalesInvoice } from "./State-Distributor/Sales/SalesInvoice.js";
import { DistributorCreateOrder } from "./State-Distributor/Orders/CreateOrder.js";
import { SubCreateNewOrder } from "./Sub-Distributor/Orders/SubCreateNewOrder.js";
// import { ViewOrderInvoice } from "./State-Distributor/Orders/ViewOrderInvoice.js";
import { StateViewInvoice } from "./State-Distributor/Invoice/OldViewInvoice.js";
import { SubSalesProduct } from "./Sub-Distributor/Sales/SalesProduct.js";
import { SubdistributorViewInvoice } from "../Components/Subdistributor-ViewInvoice.js";
import { StateSalesProduct } from "./State-Distributor/Sales/SalesProduct.js";
import { DistributorViewInvoice } from "../Components/Distributor-ViewInvoice.js";
import { StateCatalogue } from "./State-Distributor/Catalogue/Catalogue.js";
import { SubCatalogue } from "./Sub-Distributor/Catalogue/Catalogue.js";
import {
  StateViewCatalogueProduct,
  ViewCatalogueProduct,
} from "./State-Distributor/Catalogue/ViewCatalogueProduct.js";
import { SubViewCatalogueProduct } from "./Sub-Distributor/Catalogue/ViewCatalogueProduct.js";
import { SubAddProduct } from "./Sub-Distributor/Inventory/AddProduct.js";
import { StateEditRefWiseStock } from "./State-Distributor/Inventory/EditRefWiseStock.js";
import { SubEditRefWiseStock } from "./Sub-Distributor/Inventory/EditRefWiseStock.js";
import { DistributorEditInvoice } from "./State-Distributor/Invoice/EditInvoice.js";
import { EditSubInvoice } from "./Sub-Distributor/Invoice/EditInvoice.js";
import { StateCustomer } from "./State-Distributor/Customer/Customer.js";
import { SubCustomer } from "./Sub-Distributor/Customer/Customer.js";
import { matchPath } from "react-router-dom";
import { DistributorShareInvoice } from "../Components/Distributor-ShareInvoice.js";
import { SubdistributorShareInvoice } from "../Components/Subdistributor-ShareInvoice.js";

export const Layout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  const location = useLocation();
  // const isAuthRoute = ["/view-order-invoice"].includes(location.pathname);
  const isAuthPage =
    location.pathname === "/state-invoice-share" ||
    location.pathname === "/sub-invoice-share";
  // matchPath("/state-invoice-share", location.pathname);

  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) {
    return <Preloader />;
  }

  // const token = localStorage.getItem("token");
  const token = sessionStorage.getItem("token");
  const userType = sessionStorage.getItem("user_type");

  return (
    <>
      {!token ? (
        <main>
          <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="*" element={<Navigate to="/signin" replace />} />
          </Routes>
        </main>
      ) : (
        <div style={{ display: "flex" }}>
          {token && !isAuthPage && (
            <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
          )}

          <div
            style={{
              flex: 1,
              marginLeft:
                window.innerWidth >= 992 && !isAuthPage ? "250px" : "0",
              transition: "margin 0.3s",
              width: "100%",
              overflow: "auto",
            }}
          >
            {token && !isAuthPage && <Topbar toggleSidebar={toggleSidebar} />}

            <main
              style={{
                minHeight: "100vh",
                overflowX: "auto",
                backgroundColor: "#F3F4F6",
                padding: "20px",
              }}
            >
              {userType === "DISTRIBUTOR" ? (
                <Routes>
                  {/* state distributor routes  */}
                  <Route
                    path="/"
                    element={<Navigate to="/state-dashboard" />}
                  />
                  <Route
                    path="/state-invoice-view"
                    element={<DistributorViewInvoice />}
                  />
                  <Route
                    path="/state-invoice-share"
                    element={<DistributorShareInvoice />}
                  />
                  {/* dashboard */}
                  <Route path="/state-dashboard" element={<Dashboard />} />
                  {/* inventory  */}
                  <Route path="/state-inventory" element={<Inventory />} />
                  <Route
                    path="/state-inventory-view"
                    element={<InventoryView />}
                  />
                  <Route
                    path="/state-inventory-bulkAddIncomeStock"
                    element={<BulkAddIncomeStock />}
                  />
                  <Route
                    path="/state-inventory-bulkReorder"
                    element={<BulkReorder />}
                  />
                  <Route
                    path="/state-edit-refwise-stock"
                    element={<StateEditRefWiseStock />}
                  />

                  {/* Catalogue */}
                  <Route path="/state-catalogue" element={<StateCatalogue />} />
                  <Route
                    path="/state-view-catalogue"
                    element={<StateViewCatalogueProduct />}
                  />
                  {/* sales  */}

                  {/* <Route path="/state-sales" element={<Sales />} />
                  <Route path="/state-sales-newBill" element={<NewBill />} />
                  <Route path="/state-sales-view" element={<ViewSales />} />
                  */}
                  <Route path="/state-sales" element={<StateSales />} />
                  <Route
                    path="/state-sales-invoice"
                    element={<StateSalesInvoice />}
                  />
                  <Route
                    path="/state-sales-products"
                    element={<StateSalesProduct />}
                  />
                  {/* orders  */}
                  <Route path="/state-orders" element={<Orders />} />
                  <Route
                    path="/state-orders-manage"
                    element={<ManageOrders />}
                  />
                  <Route
                    path="/state-orders-create"
                    element={<DistributorCreateOrder />}
                  />
                  <Route path="/state-viewOrders" element={<ViewOrders />} />
                  {/* <Route
                    path="/view-order-invoice"
                    element={<ViewOrderInvoice />}
                  /> */}

                  {/* invoice  */}
                  <Route path="/state-invoice" element={<StateInvoice />} />
                  <Route
                    path="/state-invoice-viewDistributor"
                    element={<StateViewDistributorInvoice />}
                  />
                  <Route
                    path="/state-invoice-manageDistributor"
                    element={<StateManageDistributorsInvoice />}
                  />
                  <Route
                    path="/state-invoice-viewPos"
                    element={<StateViewPosInvoice />}
                  />
                  <Route
                    path="/state-invoice-edit"
                    element={<DistributorEditInvoice />}
                  />

                  {/* customer*/}
                  <Route path="/state-customer" element={<StateCustomer />} />

                  {/* sub distributor menu */}
                  <Route
                    path="/state-sub-distributors"
                    element={<SubDistributors />}
                  />
                  <Route
                    path="/state-view-subDistributors"
                    element={<ViewSubDistributors />}
                  />
                  <Route
                    path="/state-subdistributors-manage"
                    element={<ManageSubDistributors />}
                  />
                  <Route
                    path="/state-subdistributors-viewInvoice"
                    element={<ViewSubDistributorsInvoice />}
                  />
                  {/* payment & dues  */}
                  <Route path="/state-paymentDues" element={<PaymentDues />} />
                  <Route
                    path="/state-view-paymentsDues"
                    element={<ViewPaymentsDues />}
                  />
                  {/* quotations  */}
                  <Route path="/state-quotations" element={<Quotations />} />
                  <Route
                    path="/state-view-quotations"
                    element={<ViewQuotations />}
                  />
                  <Route
                    path="/state-newQuotations"
                    element={<NewQuotations />}
                  />
                  {/* settings */}
                  <Route path="/state-settings" element={<Settings />} />

                  <Route
                    path="*"
                    element={<Navigate to="/state-dashboard" replace />}
                  />
                </Routes>
              ) : (
                <Routes>
                  {/* sub distributor routes  */}
                  <Route path="/" element={<Navigate to="/sub-dashboard" />} />
                  <Route
                    path="/sub-invoice-view"
                    element={<SubdistributorViewInvoice />}
                  />
                  <Route
                    path="/sub-invoice-share"
                    element={<SubdistributorShareInvoice />}
                  />
                  {/* dashboard */}
                  <Route path="/sub-dashboard" element={<SubDashboard />} />
                  <Route
                    path="/sub-dashboard-viewallsales"
                    element={<SubViewAllSales />}
                  />
                  <Route
                    path="/sub-dashboard-viewSalesInvoice"
                    element={<SubViewSalesInvoice />}
                  />
                  {/* inventory */}
                  <Route path="/sub-inventory" element={<SubInventory />} />
                  <Route
                    path="/sub-inventory-addincomestock"
                    element={<SubAddIncomeStock />}
                  />
                  <Route
                    path="/sub-inventory-reorder"
                    element={<SubReorder />}
                  />
                  <Route
                    path="/sub-edit-refwise-stock"
                    element={<SubEditRefWiseStock />}
                  />
                  <Route path="/sub-add-product" element={<SubAddProduct />} />
                  {/* Catalogue */}
                  <Route path="/sub-catalogue" element={<SubCatalogue />} />
                  <Route
                    path="/sub-view-catalogue"
                    element={<SubViewCatalogueProduct />}
                  />

                  {/* sales  */}
                  <Route path="/sub-sales" element={<SubSales />} />
                  <Route
                    path="/sub-sales-invoice"
                    element={<SubSalesInvoice />}
                  />
                  <Route
                    path="/sub-sales-products"
                    element={<SubSalesProduct />}
                  />
                  {/* orders  */}
                  <Route path="/sub-orders" element={<SubOrders />} />
                  <Route
                    path="/sub-orders-addIncomeStock"
                    element={<SubOrdersAddIncomeStock />}
                  />
                  <Route
                    path="/sub-orders-reorder"
                    element={<SubOrdersReorder />}
                  />
                  <Route
                    path="/sub-create-order"
                    element={<SubCreateNewOrder />}
                  />
                  {/* invoice  */}
                  <Route path="/sub-invoice" element={<SubInvoice />} />
                  <Route
                    path="/sub-invoice-viewDistributor"
                    element={<ViewDistributorInvoice />}
                  />
                  <Route
                    path="/sub-invoice-manageDistributor"
                    element={<ManageDistributorsInvoice />}
                  />
                  <Route
                    path="/sub-invoice-viewPos"
                    element={<ViewPosInvoice />}
                  />
                  <Route
                    path="/sub-invoice-edit"
                    element={<EditSubInvoice />}
                  />

                  {/* customer*/}
                  <Route path="/sub-customer" element={<SubCustomer />} />

                  {/* quotations  */}
                  <Route path="/sub-quotations" element={<SubQuotations />} />
                  <Route
                    path="/sub-view-quotations"
                    element={<SubViewQuotations />}
                  />
                  <Route
                    path="/sub-newQuotations"
                    element={<SubNewQuotations />}
                  />
                  {/* settings */}
                  <Route path="/sub-settings" element={<SubSettings />} />

                  <Route
                    path="*"
                    element={<Navigate to="/sub-dashboard" replace />}
                  />
                </Routes>
              )}
            </main>
          </div>
        </div>
      )}
    </>
  );
};
